import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { translatedObjectSignal } from '@advania-cosoftware/wolf-core';

import { VersionUpdateDialogText, versionUpdateDialogTextKey } from './version-update-dialog.translations';

interface VersionUpdateDialogData {
    onUpdateNow: () => Promise<boolean>;
    onReloadPage: () => void;
}

@Component({
    selector: 'app-version-update-dialog',
    templateUrl: './version-update-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonDirective],
})
export class VersionUpdateDialogComponent {
    private readonly _dialogConfig = inject(DynamicDialogConfig<VersionUpdateDialogData>);
    protected readonly text = translatedObjectSignal<VersionUpdateDialogText>(versionUpdateDialogTextKey);
    protected updateFailed = false;

    async updateNow(): Promise<void> {
        this.updateFailed = !(await this._dialogConfig.data.onUpdateNow());
    }

    reloadPage(): void {
        this._dialogConfig.data.onReloadPage();
    }

    buttonAction(): void | Promise<void> {
        if (this.updateFailed) {
            this.reloadPage();
            return;
        }

        return this.updateNow();
    }
}
